// @ts-expect-error untyped module
import { createCustomObjectGetter } from 'reference-resolvers/formatters/formatCustomObjects';
export const getId = createCustomObjectGetter('hs_flow_id');
export const getLabel = createCustomObjectGetter('hs_name');